import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const setParallax = () => {
  const els = document.querySelectorAll('.js-parallax')

  els.forEach((target) => {
    const img = target.querySelector('img')
    if (!img) return

    const isLeft = target.classList.contains('left')
    const base = (100 / 1.2 - 100) / 2
    const direction = isLeft ? 1 : -1

    gsap.set(target, {
      overflow: 'hidden',
    })

    gsap.set(img, {
      scale: 1.2,
    })

    gsap.fromTo(
      img,
      {
        yPercent: base * direction,
      },
      {
        yPercent: -base * direction,
        ease: 'power4.out',
        scrollTrigger: {
          trigger: target,
          start: 'top 75%',
          end: 'bottom top',
          scrub: 0.5,
        },
      })
  })
}

export default setParallax;
